import { render, staticRenderFns } from "./arrows-left-outlined.vue?vue&type=template&id=f074bec4&scoped=true&"
var script = {}
import style0 from "./arrows-left-outlined.vue?vue&type=style&index=0&id=f074bec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f074bec4",
  null
  
)

export default component.exports